import styled from "styled-components/macro"
import { RadioGroup } from "@material-ui/core"

export const Form = styled.div`
  display: grid;
  margin-top: 24px;
`

export const SelectWrapper = styled.div`
  padding: 0 0 24px 2px;
`

export const TypeRadioGroup = styled(RadioGroup)`
    display: flex;
    flex-direction: column;
`
